import Gauge from './Gauge';

export default Gauge;
export { gaugeClasses } from './Gauge';
